import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Globe, Users, ArrowLeft } from "lucide-react";

export default function WhySecureID() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                {/* Header */}
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="SecureID" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Why SecureID</h1>
                </div>

                <p className="text-gray-600 mb-8 leading-relaxed">
                    SecureID Technologies provides identity, testing, and compliance solutions built with one
                    core mission � <span className="font-semibold text-indigo-700">to protect data integrity and trust</span>.
                    Our platforms combine security, usability, and scalability for government, education, and enterprise use.
                </p>

                {/* Features Grid */}
                <section className="grid md:grid-cols-2 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <ShieldCheck className="w-5 h-5" />
                            <h3 className="font-semibold">Secure by Design</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� SOC 2 Type II & ISO 27001 alignment</li>
                            <li>� End-to-end encryption (AES-256, TLS 1.3)</li>
                            <li>� Zero-trust access policies</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Users className="w-5 h-5" />
                            <h3 className="font-semibold">Customer-Centered</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� U.S.-based support & onboarding</li>
                            <li>� Transparent pricing & SLAs</li>
                            <li>� Tailored deployments for agencies</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Lock className="w-5 h-5" />
                            <h3 className="font-semibold">Privacy First</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Data residency options within the U.S.</li>
                            <li>� No external data sharing or training on user data</li>
                            <li>� Full transparency in retention and audit logs</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Globe className="w-5 h-5" />
                            <h3 className="font-semibold">Proven & Scalable</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Cloud-native architecture on Azure</li>
                            <li>� Horizontal scaling for thousands of sessions</li>
                            <li>� Continuous monitoring & telemetry</li>
                        </ul>
                    </div>
                </section>

                {/* CTA Buttons */}
                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link
                        to="/contact"
                        className="bg-indigo-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-indigo-700 transition"
                    >
                        Talk to Our Team
                    </Link>
                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-5 py-2.5 rounded-full font-semibold transition"
                    >
                        <ArrowLeft className="w-4 h-4" /> Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
